import { IPreloadCacheContext } from 'framework/context/IPreloadCacheContext';
import { ICalendarResourcesDto } from 'gen/ApiClient';
import React from 'react';

export const CalendarResourcesPreloadCacheContext = React.createContext<IPreloadCacheContext<ICalendarResourcesDto>>(undefined as any);
